var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 399,
    viewBox: "0 0 401 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.469 215.638C300.469 212.781 300.469 211.353 300.469 208.497C300.469 112.813 243.344 28.5532 160.512 1.41885C146.231 4.2751 131.95 8.55947 119.097 14.272C173.366 57.1157 206.213 121.381 209.069 191.359C239.059 207.069 270.478 214.209 300.469 215.638Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.644 217.066C170.509 234.203 147.659 257.053 131.95 284.188C133.378 285.616 136.234 287.044 137.663 287.044C221.922 335.6 324.747 327.031 389.013 267.05C393.297 254.197 397.581 239.916 399.009 225.634C370.447 238.488 339.028 244.2 307.609 244.2C269.05 244.2 231.919 235.631 197.644 217.066Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.459 208.497C330.459 209.925 330.459 212.781 330.459 214.209C354.738 211.353 379.016 204.213 400.438 192.788C397.581 92.8188 320.462 9.9876 221.922 -0.00927734C286.188 42.8345 330.459 121.381 330.459 208.497Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.663 81.3939C139.091 79.9657 140.519 79.9657 141.947 78.5376C129.094 59.972 111.956 42.8345 93.3906 29.9813C37.6937 65.6845 0.5625 128.522 0.5625 198.5C0.5625 221.35 4.84687 244.2 11.9875 264.194C21.9844 191.359 66.2563 121.381 137.663 81.3939Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.913 347.025C207.641 347.025 163.369 335.6 121.953 311.322C120.525 309.894 119.097 309.894 117.669 308.466C109.1 328.459 103.387 349.881 100.531 371.303C129.094 388.441 163.369 398.438 199.072 398.438C261.909 398.438 319.034 368.447 354.737 322.747C324.747 338.456 289.044 347.025 251.913 347.025Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.934 192.788C180.506 161.369 171.938 129.95 157.656 102.816C156.228 104.244 153.372 104.244 151.944 105.672C71.9688 151.372 29.125 237.059 40.55 318.463C50.5469 331.316 61.9719 344.169 74.825 354.166C86.25 288.472 124.809 228.491 181.934 192.788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.5ec778e5003e407ca5721e69bfeadb51.svg";
export { ForwardRef as ReactComponent };